// Locales
import localeEn from 'react-intl/locale-data/en';
import localeEs from 'react-intl/locale-data/es';

// Dates
import 'moment/locale/en-gb';
import 'moment/locale/es';

import { IS_TENANT } from 'tenant/config';
import { getMessagesByTenant } from './messages-by-tenant/get-messages-by-tenant';

const messages = getMessagesByTenant();

const en_GB_config = {
  messages: messages.en_GB,
  locale: 'en',
  formats: {
    number: {
      price: {
        style: 'currency',
        currency: 'EUR',
      },
    },
  },
};

const es_ES_config = {
  messages: messages.es_ES,
  locale: 'es',
  formats: {
    number: {
      price: {
        style: 'currency',
        currency: 'EUR',
      },
    },
  },
};

let selectedConfig = en_GB_config;

if (IS_TENANT) {
  selectedConfig = es_ES_config;
}

const intlConfig = {
  default: selectedConfig,
  // Duplicated as it's used the lang code, to avoid problems now
  en: en_GB_config,
  en_GB: en_GB_config,
  es: es_ES_config,
  es_ES: es_ES_config,
};

const locales = [...localeEn, ...localeEs];

export { intlConfig, locales };
